import { faArrowsSplitUpAndLeft } from '@fortawesome/free-solid-svg-icons';
import type { JSX } from 'react';
import { memo } from 'react';

import TimelineHeader from '@/pages/Timeline/components/TimelineHeader/TimelineHeader';
import TimestampAndActor from '@/pages/Timeline/components/TimestampAndActor/TimestampAndActor';
import { TimelineSubcomponentProps } from '@/pages/Timeline/types';
import Card from '@/ui/components/Card';

// const dataExample = {
//   backfill: true,
//   actor_email: 'example@affecttherapeutics.com',
//   program_name: 'Alcohol Program - Standard',
//   to_phase_name: 'early_intensive',
//   from_phase_name: null,
//   start_at_datetime: '2023-07-13T01:30:00.001+00:00',
//   length_of_time_in_phase_in_days: 0
// };

const PhaseEvent = ({ activityLog }: TimelineSubcomponentProps): JSX.Element => {
  const { actor, data, timestamp } = activityLog;

  return (
    <div>
      <Card>
        <TimelineHeader
          icon={faArrowsSplitUpAndLeft}
          iconClassName="text-yellow-500"
          subtitle={data?.to_phase_name && `to ${data.to_phase_name}`}
          title="Phase Updated"
        />

        <div>{data?.from_phase_name && <span>from {data.from_phase_name}</span>} </div>
      </Card>

      <TimestampAndActor actor={actor} timestamp={timestamp} />
    </div>
  );
};

export default memo(PhaseEvent);
